<template>
    <div class="md:container">
        <Xandr
            xandr-wrapper="sponsored_course_headerWrapper"
            xandr-slot="sponsored_course_header"
            is-sponsored-header
        ></Xandr>
        <div class="relative flex w-full flex-col cursor-default mb-6 md:rounded-lg shadow">
            <div :class="['relative md:rounded-lg', { 'bg-black': sponsoringHeader }]">
                <div
                    :class="[
                        {
                            yellow: !sponsoringHeader,
                            'opacity-75': sponsoringHeader,
                        },
                        'bg-center bg-no-repeat bg-cover background md:rounded-lg absolute left-0 top-0 right-0 bottom-0 transition-all ease-linear duration-300',
                    ]"
                    :style="sponsoringHeaderStyle"
                ></div>

                <div :class="['w-full pt-4 md:pt-6 md:pb-6 md:px-6', { 'text-white': sponsoringHeader }]">
                    <div class="relative flex flex-col-reverse items-start w-full md:flex-col">
                        <div class="flex flex-col w-full">
                            <div class="flex flex-col md:flex-col">
                                <div class="max-md:container">
                                    <h1
                                        :class="{
                                            'pr-12 md:pr-48': inGroup(group.id),
                                            'md:pr-24': !inGroup(group.id),
                                        }"
                                        class="break-words mb-4 md:mb-3 line-clamp-3 md:line-clamp-2 font-display-3 lg:font-display-2"
                                        v-text="group.name"
                                    ></h1>
                                    <div
                                        :class="[
                                            'flex flex-col items-start w-full md:flex-row',
                                            sponsoringHeader !== null ? 'text-white' : ' text-slate-600',
                                        ]"
                                    >
                                        <p class="flex flex-row items-center mb-6 md:mb-5 md:pr-4">
                                            <i class="mr-2 icon icon-people"></i><span v-text="group.members"></span>
                                        </p>
                                    </div>
                                </div>
                                <div class="flex flex-row justify-between w-full mb-6 md:mb-0 max-md:container">
                                    <!-- native modifier has been removed, please confirm whether the function has been affected  -->
                                    <BtnCta
                                        variant="secondary"
                                        class="cta-group w-full md:w-auto"
                                        :icon="
                                            hasJoinedGroup && !joiningGroup && !userGroupsInProgress
                                                ? 'checkmark-stroke'
                                                : null
                                        "
                                        :label="btnLabel"
                                        :disabled="hasJoinedGroup"
                                        @click="join"
                                    />
                                    <portal-target name="sponsoringBtn"></portal-target>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <GroupShowMenu
                :with-banner="sponsoringHeader !== null"
                :class="{
                    'md:text-white text-black': sponsoringHeader,
                }"
            />
            <XandrSponsoredHeader
                v-if="sponsoringAd"
                :xandr-ad="sponsoringAd"
            />
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { Xandr, XandrSponsoredHeader } from '@components/Xandr';
import { get } from 'lodash-es';
import { useTranslation } from 'i18next-vue';
import GroupShowMenu from './GroupShowMenu.vue';

export default {
    name: 'GroupShowHeader',
    components: {
        Xandr,
        GroupShowMenu,
        XandrSponsoredHeader,
    },
    setup() {
        const { t } = useTranslation('group');
        return { t };
    },
    computed: {
        ...mapGetters({
            screen: 'ui/screen',
            group: 'group/group',
            leavingGroup: 'group/leaveProgress',
            joiningGroup: 'group/joinProgress',
            userGroupsInProgress: 'user/groupsProgress',
            sponsoringAd: 'xandr/xandrSponsoringAd',
            userGroups: 'user/groups',
            inGroup: 'user/inGroup',
        }),
        ...mapGetters({ user: 'auth/user' }),
        sponsoringHeader() {
            const header = get(this.sponsoringAd, 'header_background', null);
            const mobileHeader = get(this.sponsoringAd, 'mobile_header_background', null);

            return this.screen.maxMD ? mobileHeader : header;
        },
        sponsoringHeaderStyle() {
            if (this.sponsoringHeader) {
                return {
                    'background-image': `url(${this.sponsoringHeader})`,
                };
            }
            return {};
        },
        hasJoinedGroup() {
            return this.joiningGroup || this.userGroupsInProgress || this.inGroup(this.group.id);
        },
        btnLabel() {
            if (this.joiningGroup) {
                return this.t('header.cta_progress');
            }
            if (this.userGroupsInProgress) {
                return this.t('header.cta_loading');
            }
            if (!this.inGroup(this.group.id)) {
                return this.t('header.cta');
            }
            return this.t('header.cta_disabled');
        },
    },
    methods: {
        openRegistrationPopup() {
            this.$store.dispatch('ui/openRegistration', {
                authTrigger: 'joinGroup',
            });
        },
        join() {
            if (!this.user) {
                this.openRegistrationPopup();
            } else if (!this.inGroup(this.group.id) && !(this.leavingGroup || this.joiningGroup)) {
                this.$store.dispatch('group/join', this.group);
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.background {
    &.yellow {
        background-image: url(/images/backgrounds/background-yellow-shape-2.svg);
    }
}
</style>
